/* Aarwaan Editorial — small, dependency-free interactions for the homepage sections. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* On desktop the Horizon theme scrolls .page-wrapper instead of the window.
     A capturing listener on document hears scrolling from either one. */
  function onAnyScroll(fn) {
    document.addEventListener('scroll', fn, { passive: true, capture: true });
  }
  function scrollTop() {
    var pw = document.querySelector('.page-wrapper');
    return window.scrollY || (pw ? pw.scrollTop : 0);
  }

  function splitWords(node) {
    [].slice.call(node.childNodes).forEach(function (n) {
      if (n.nodeType === 3) {
        var frag = document.createDocumentFragment();
        n.textContent.split(/(\s+)/).forEach(function (t) {
          if (!t) return;
          if (/^\s+$/.test(t)) frag.appendChild(document.createTextNode(t));
          else { var s = document.createElement('span'); s.className = 'w'; s.textContent = t; frag.appendChild(s); }
        });
        node.replaceChild(frag, n);
      } else if (n.nodeType === 1) splitWords(n);
    });
  }

  function init(root) {
    root = root || document;

    root.querySelectorAll('[data-aw-fill]:not([data-aw-ready])').forEach(function (el) {
      el.setAttribute('data-aw-ready', '');
      splitWords(el);
      var words = [].slice.call(el.querySelectorAll('.w'));
      if (reduce) { words.forEach(function (w) { w.classList.add('on'); }); return; }
      var tick = false;
      function update() {
        var r = el.getBoundingClientRect(), vh = window.innerHeight;
        var p = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (r.height + vh * 0.35)));
        var n = Math.round(p * words.length);
        words.forEach(function (w, i) { w.classList.toggle('on', i < n); });
        tick = false;
      }
      onAnyScroll(function () { if (!tick) { requestAnimationFrame(update); tick = true; } });
      update();
    });

    root.querySelectorAll('[data-aw-parallax]:not([data-aw-ready])').forEach(function (el) {
      el.setAttribute('data-aw-ready', '');
      if (reduce) return;
      var tick = false;
      function update() {
        var y = scrollTop();
        el.style.transform = window.innerWidth > 860 ? 'translateY(' + y * 0.12 + 'px) rotate(' + y * 0.004 + 'deg)' : '';
        tick = false;
      }
      onAnyScroll(function () { if (!tick) { requestAnimationFrame(update); tick = true; } });
    });

    root.querySelectorAll('[data-aw-covers]:not([data-aw-ready])').forEach(function (sec) {
      sec.setAttribute('data-aw-ready', '');
      var track = sec.querySelector('.aw-covers');
      function step(dir) {
        var c = track.querySelector('.aw-cover');
        if (c) track.scrollBy({ left: dir * (c.offsetWidth + 20), behavior: reduce ? 'auto' : 'smooth' });
      }
      var prev = sec.querySelector('[data-aw-prev]'), next = sec.querySelector('[data-aw-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    });

    var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    root.querySelectorAll('[data-aw-index]:not([data-aw-ready])').forEach(function (sec) {
      sec.setAttribute('data-aw-ready', '');
      var peek = sec.querySelector('.aw-peek');
      if (!fine || !peek) return;
      var owner = (sec.closest('.shopify-section') || sec).id || 'aw-index';
      document.querySelectorAll('body > .aw-peek[data-aw-owner="' + owner + '"]').forEach(function (old) { old.remove(); });
      peek.setAttribute('data-aw-owner', owner);
      document.body.appendChild(peek);
      var imgs = [].slice.call(peek.querySelectorAll('img'));
      sec.querySelectorAll('.aw-prow').forEach(function (row) {
        row.addEventListener('mouseenter', function () {
          imgs.forEach(function (im) { im.classList.toggle('on', im.dataset.peek === row.dataset.peek); });
          peek.classList.add('on');
        });
        row.addEventListener('mouseleave', function () { peek.classList.remove('on'); });
        row.addEventListener('mousemove', function (e) {
          var x = Math.min(e.clientX + 170, window.innerWidth - 140);
          var y = Math.min(Math.max(e.clientY, 180), window.innerHeight - 180);
          peek.style.left = x + 'px'; peek.style.top = y + 'px';
        });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
